<template>
  <div>
    <div>
      <div>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Cценарий:"
          label-for="input-default"
        >
          <b-form-select
            id="input-default"
            v-model="scenarioId"
            :options="scenarios()"
            @change="onChangeScenario"
          />
        </b-form-group>
      </div>
      <div
        v-if="scenarioId && dataReady"
        style="max-height: 80vh; overflow: auto;"
      >
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th />
              <th>Код</th>
              <th>Специальность</th>
              <th>Всего</th>
              <th
                v-for="ct in qryContrType.recordset.records"
                :key="ct.id.value"
              >
                {{ ct.name.value }}
              </th>
            </tr>
            <tr>
              <th />
              <th>0</th>
              <th>ВСЕГО</th>
              <th><cbs-cell-number :value="getGrandTotal()" /></th>
              <th
                v-for="ct in qryContrType.recordset.records"
                :key="ct.id.value"
              >
                <cbs-cell-number :value="getColumnTotal(ct)" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in getTableRows()"
              :key="rowKey(row)"
            >
              <td>
                <div
                  v-if="row.mode === 'level' || row.mode === 'school'"
                  class="d-flex justify-content-center align-items-center"
                  style="cursor: pointer;"
                >
                  <feather-icon
                    v-if="!row.cbs_expanded"
                    :class="row.mode === 'level' ? '' : 'ml-2'"
                    icon="PlusSquareIcon"
                    @click="triggerRow(row)"
                  />
                  <feather-icon
                    v-if="row.cbs_expanded"
                    :class="row.mode === 'level' ? '' : 'ml-2'"
                    icon="MinusSquareIcon"
                    @click="triggerRow(row)"
                  />
                </div>
              </td>
              <td>
                <div v-if="row.mode === 'level'">
                  {{ row.eduLevel.code }}
                </div>
                <div v-if="row.mode === 'school'">
                  {{ row.school.code }}
                </div>
                <div v-if="row.mode === 'spec'">
                  {{ row.spec.code }}
                </div>
              </td>
              <td>
                <div v-if="row.mode === 'level'">
                  {{ row.eduLevel.title }} ({{ row.eduLevel.value }})
                </div>
                <div
                  v-if="row.mode === 'school'"
                  class="ml-1"
                >
                  {{ row.school.title }} ({{ row.school.value }})
                </div>
                <div
                  v-if="row.mode === 'spec'"
                  class="ml-2"
                >
                  {{ row.spec.title }} ({{ row.spec.value }})
                </div>
              </td>
              <td><cbs-cell-number :value="getRowTotal(row)" /></td>
              <td
                v-for="ct in qryContrType.recordset.records"
                :key="ct.id.value"
                :style="row.mode === 'spec' ? 'background: lightyellow;' : ''"
              >
                <cbs-cell-number
                  v-if="row.mode === 'level' || row.mode === 'school'"
                  :value="getCellTotal(row, ct)"
                />
                <cbs-cell-editable
                  v-else
                  :record="getRecord(row, ct)"
                  key-value="qty"
                  align="right"
                  value-type="number"
                  :no-next-cell="true"
                  @edit="onEditRecord(getRecord(row, ct), 'qty', $event)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div />
    <cbs-debug
      v-if="useCubus.isRoot"
      :context="this"
    />
  </div>
</template>

<script>
import useCubus from '@/cubus/services/useCubus'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import {
  BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import CbsCellNumber from '@/cubus/components/cbs-form/generic-forms/number-cell/CbsCellNumber.vue'
import CbsCellEditable from '@/cubus/components/cbs-form/generic-forms/cell-editable/CbsCellEditable.vue'

export default {
  name: 'CbsNxzRecruit',
  components: {
    CbsCellEditable,
    CbsCellNumber,
    CbsDebug,
    BFormSelect,
    BFormGroup,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      qryScenario: null,
      qryScenarioParam: {
        keymode: 'sid',
        objectsid: 'scenario_budget',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'scenario' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      },
      scenarioId: null,
      qrySpeciality: null,
      qrySpecialityParam: {
        keymode: 'sid',
        objectsid: 'nxz_edu_speciality',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'code' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      },
      eduLevels: null,
      qryContrType: null,
      qryContrTypeParam: {
        keymode: 'sid',
        objectsid: 'nxz_edu_contr_type',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'code' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      },
      rowTree: [],
      rows: [],
      qryLevel: null,
      qryLevelParam: {
        keymode: 'sid',
        objectsid: 'nxz_edu_level',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'code' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      },
      qrySchool: null,
      qrySchoolParam: {
        keymode: 'sid',
        objectsid: 'nxz_edu_school',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'code' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      },
      qryData: null,
      dataReady: false,
      firstCource: { value: 1, title: '1 курс' },
    }
  },
  setup() {
    return {
      useCubus,
    }
  },
  watch: {
    scenarioId(newVal) {
      if (newVal) {
        this.qryData = null
        this.init()
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.dataReady = false
      this.loadRefs()
      // this.loadQryScenario()
    },
    async loadQryScenario() {
      this.qryScenario = await useCubus.loadQuery(this, this.qryScenarioParam)
      this.loadQrySpeciality()
    },
    scenarios() {
      if (!this.qryScenario || !this.qryScenario.recordset || !this.qryScenario.recordset.records) return []
      return this.qryScenario.recordset.records.map(rec => ({
        value: rec.scenario.value,
        text: rec.scenario.title,
        sid: rec.scenario.sid,
      }))
    },
    onChangeScenario() {
      // console.log('onChangeScenario')
    },
    async loadQrySpeciality() {
      this.qrySpeciality = await useCubus.loadQuery(this, this.qrySpecialityParam)
      this.initEduLevels()
      this.loadQryContrType()
    },
    initEduLevels() {
      const lvls = Array.from(new Map(this.qrySpeciality.recordset.records.map(r => [r.nxz_edu_level.value, r.nxz_edu_level])).values())
      this.eduLevels = lvls.map(l => ({
        value: l.value,
        title: l.title,
        code: this.qryLevel.recordset.records.find(r => r.id.value === l.value)?.code.value || '',
        cbs_expanded: false,
      }))
    },
    async loadQryContrType() {
      this.qryContrType = await useCubus.loadQuery(this, this.qryContrTypeParam)
      this.initRows()
    },
    getSchools(eduLevel) {
      return Array.from(
        new Map(
          this.qrySpeciality.recordset.records
            .filter(r => r.nxz_edu_level.value === eduLevel.value)
            .map(r => [r.nxz_edu_school.value, {
              value: r.nxz_edu_school.value,
              title: r.nxz_edu_school.title,
              code: this.qrySchool.recordset.records.find(s => s.id.value === r.nxz_edu_school.value)?.code.value || '',
            }]),
        ).values(),
      ).map(el => ({
        mode: 'school',
        eduLevel,
        school: el,
        cbs_expanded: false,
        subRows: [],
      }))
    },
    initRows() {
      this.rowTree = this.eduLevels.map(lvl => ({
        mode: 'level', eduLevel: lvl, cbs_expanded: false, subRows: [],
      }))
      if (this.scenarioId) this.loadQryData()
    },
    rowKey(row) {
      if (row.mode === 'level') return `lvl_${row.eduLevel.value}`
      if (row.mode === 'school') return `school_${row.eduLevel.value}_${row.school.value}`
      return `unknown_${Math.random()}`
    },
    triggerRow(row) {
      const r = row
      r.cbs_expanded = !r.cbs_expanded
      if (r.cbs_expanded && r.subRows.length === 0) {
        if (r.mode === 'level') {
          r.subRows = this.getSchools(r.eduLevel)
        }
        if (r.mode === 'school') {
          r.subRows = this.getSpecs(r.eduLevel, r.school)
        }
      }
    },
    getTableRows() {
      const rows = []
      this.rowTree.forEach(row => {
        this.addTableRow(rows, row)
      })
      return rows
    },
    addTableRow(rows, row) {
      rows.push(row)
      if (row.cbs_expanded && row.subRows && row.subRows.length > 0) {
        row.subRows.forEach(subRow => {
          this.addTableRow(rows, subRow)
        })
      }
    },
    getSpecs(eduLevel, school) {
      return Array.from(
        new Map(
          this.qrySpeciality.recordset.records
            .filter(r => r.nxz_edu_level.value === eduLevel.value && r.nxz_edu_school.value === school.value)
            .map(r => [r.id.value, { value: r.id.value, title: r.name.value, code: r.code.value }]),
        ).values(),
      ).map(el => ({
        mode: 'spec',
        eduLevel,
        school,
        spec: el,
        cbs_expanded: false,
      }))
    },
    async loadRefs() {
      this.qryLevel = await useCubus.loadQuery(this, this.qryLevelParam)
      this.qrySchool = await useCubus.loadQuery(this, this.qrySchoolParam)
      this.loadQryScenario()
    },
    qryDataParam() {
      return {
        keymode: 'sid',
        objectsid: 'cube_nxz_recruit',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'scenario' },
                  { type: { sid: 'value' }, value: this.scenarioId },
                ],
              },
            ],
          },
        },
        orderby: {
          isActive: true,
          sorts: [
            {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: 'code' },
            },
          ],
        },
        limit: 1000,
        withsubrecords: false,
      }
    },
    async loadQryData() {
      this.qryData = await useCubus.loadQuery(this, this.qryDataParam())
      this.qryData.recordset.records.forEach(r => this.$set(r, 'cbs_access', 'rw'))
      this.dataReady = true
    },
    getGrandTotal() {
      return this.qryData.recordset.records.reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
    },
    getColumnTotal(col) {
      return this.qryData.recordset.records.filter(r => r.nxz_edu_contr_type.value === col.id.value).reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
    },
    getRowTotal(row) {
      if (row.mode === 'level') {
        return this.qryData.recordset.records.filter(r => r.nxz_edu_level.value === row.eduLevel.value).reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      if (row.mode === 'school') {
        return this.qryData.recordset.records.filter(r => r.nxz_edu_level.value === row.eduLevel.value && r.nxz_edu_school.value === row.school.value).reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      if (row.mode === 'spec') {
        return this.qryData.recordset.records.filter(r => r.nxz_edu_level.value === row.eduLevel.value && r.nxz_edu_school.value === row.school.value && r.nxz_edu_speciality.value === row.spec.value).reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      return '???'
    },
    getCellTotal(row, col) {
      if (row.mode === 'level') {
        return this.qryData.recordset.records
          .filter(r => r.nxz_edu_level.value === row.eduLevel.value && r.nxz_edu_contr_type.value === col.id.value)
          .reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      if (row.mode === 'school') {
        return this.qryData.recordset.records
          .filter(r => r.nxz_edu_level.value === row.eduLevel.value
            && r.nxz_edu_school.value === row.school.value
            && r.nxz_edu_contr_type.value === col.id.value)
          .reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      if (row.mode === 'spec') {
        return this.qryData.recordset.records
          .filter(r => r.nxz_edu_level.value === row.eduLevel.value
              && r.nxz_edu_school.value === row.school.value
              && r.nxz_edu_speciality.value === row.spec.value
              && r.nxz_edu_contr_type.value === col.id.value)
          .reduce((acc, rec) => acc + (rec.qty.value || 0), 0)
      }
      return '???'
    },
    getRecord(row, col) {
      const rec = this.qryData.recordset.records.find(r => r.nxz_edu_level.value === row.eduLevel.value
          && r.nxz_edu_school.value === row.school.value
          && r.nxz_edu_speciality.value === row.spec.value
          && r.nxz_edu_contr_type.value === col.id.value)
      if (rec) return rec
      const newRec = this.getNewRecord(row, col)
      this.qryData.recordset.records.push(newRec)
      return newRec
    },
    getNewRecord(row, col) {
      const n = this.getDefaultRecord()
      n.scenario.value = this.scenarioId
      n.nxz_edu_level.value = row.eduLevel.value
      n.nxz_edu_school.value = row.school.value
      n.nxz_edu_speciality.value = row.spec.value
      n.nxz_edu_contr_type.value = col.id.value
      n.nxz_edu_cource.value = this.firstCource.value
      n.cbs_access = 'rw'
      return n
    },
    getDefaultRecord() {
      const n = {}
      this.qryData.columns.forEach(c => {
        if (c.key !== 'actions') {
          n[c.entitysid] = {}
          n[c.entitysid].value = c.default.value
          n[c.entitysid].title = c.default.title
        }
      })
      return n
    },
    onEditRecord(rec, key, newValue) {
      const r = rec
      r[key].value = newValue
      r[key].status = 'changed'
      this.saveRecord(rec)
    },
    async saveRecord(record) {
      try {
        const saved = await useCubus.saveRecord(this, { keymode: 'sid', objectsid: 'cube_nxz_recruit', record })
        this.afterSave(record, saved)
      } catch (e) { console.error(e) }
    },
    afterSave(initRec, savedRec) {
      console.log('initRec', initRec)
      const i = initRec
      const s = savedRec; s.status = 'saved'
      this.qryData.columns.forEach(fld => {
        if (fld.key !== 'actions') {
          i[fld.entitysid].value = savedRec[fld.entitysid].value
          i[fld.entitysid].title = savedRec[fld.entitysid].title
        }
      })
      i.status = 'saved'
    },
  },
}
</script>

<style scoped>
.table {
  border-collapse: separate;
  border-spacing: 0;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
}

.table th:first-child,
.table td:first-child {
  min-width: 54.5px;
  max-width: 54.5px;
  box-sizing: border-box;
  position: sticky;
  left: 0;
  background: white;
  z-index: 3;
}

.table th:nth-child(2),
.table td:nth-child(2) {
  min-width: 80px;
  box-sizing: border-box;
  position: sticky;
  left: 54.5px; /* такое же значение как min-width у предыдущей */
  background: white;
  z-index: 2;
}

</style>
